module.exports = __webpack_public_path__ + "img/8_u.3a9541c8.jpg";